import React from 'react'
import { useEffect, useState } from 'react'
import { cancelToken, get, isEmpty, MdShare, post } from '@fareye/utils'
import {
  Card,
  Flex,
  Label,
  layout,
  Modal,
  RenderControl,
  Span,
  styled,
  Table
} from '@fareye/ui'
import CopyText from './components/CopyText'

const ColFullHeight = styled((props: any) => (
  <Flex
    p={2}
    justifyContentSpaceEvenly
    alignItemsFlexStart
    column
    {...props}
    style={{ height: '100%', overflow: 'hidden' }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`

const ModalNew: any = styled(Modal)`
  overflow: hidden;
`

const NewLabel: any = styled(Label)`
  cursor: 'pointer',
  marginLeft: '12px',
  color: '#217CE7'
`

export const Hubs = function(props: any) {
  const { config } = props
  const [recordsPerPage, setRecordsPerPage] = React.useState(10)
  const [hubList, setHubList] = React.useState<any>({
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
  })
  const [share, setShare] = React.useState<any>({
    data: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: ''
  })
  const { shareURL, hubList: hubListConfig } = config.config
  const source = cancelToken().source()
  const [pageNo, setPageNo] = React.useState(0)
  function onPageSizeChange(pageSize: number) {
    setRecordsPerPage(pageSize)
  }
  React.useEffect(() => {
    setPageNo(0)
  }, [])

  async function getHubList(apiURL: any) {
    setHubList({
      ...hubList,
      data: [],
      isLoading: true
    })
    try {
      const url = `${apiURL}`
      const resp = await get(url, source.token)
      const { status, data } = resp
      if (status >= 200 && status < 300) {
        setHubList({
          ...hubList,
          data: data.data,
          isLoading: false,
          isSuccess: true,
          message: isEmpty(data.data) ? 'No Data Found' : ''
        })
      }
    } catch (e:any) {
      setHubList({
        ...hubList,
        data: [],
        isLoading: false,
        message: 'No Data Found....'
      })
      console.error(`Could not fetch Hubs List, `, e)
    }
  }

  useEffect(() => {
    getHubList(hubListConfig?.apiURL)
  }, [])

  async function fetchShareSlug(id: any) {
    setShare({ ...share, isLoading: true })
    try {
      const url = `${shareURL}?hubId=${id}`
      const resp = await post(url, {}, source.token)
      const { data } = resp
      if (data.link && !data.error) {
        const linkList = [
          `${data.link}&view=arrival`,
          `${data.link}&view=departure`,
          `${data.link}&view=arrival_departure`
        ]
        setShare({
          ...share,
          data: linkList,
          isSuccess: true,
          isLoading: false
        })
      }
    } catch (error) {
      console.error('App Error:', error)
      setShare({ ...share, isError: true, isLoading: false })
    }
  }

  function getTableColumns(): any[] {
    return [
      {
        Header: 'Hubs',
        id: 'hubs',
        width: 100,
        accessor: 'label',
        filterable: false,
        sortable: false
      },
      {
        Header: 'Link',
        id: 'link',
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          return (
            <NewLabel onClick={() => fetchShareSlug(original.value)}>
              <MdShare style={{ marginBottom: '-2px' }} />
              {` Share`}
            </NewLabel>
          )
        }
      }
    ]
  }

  const { data } = hubList

  return (
    <RenderControl state={hubList} style={{ padding: '0.5em' }}>
      {data.length && (
        <>
          <Table
            data={data}
            columns={getTableColumns()}
            className="striped responsive"
            onPageChange={(pageIndex: number) => setPageNo(pageIndex)}
            totalElements={data.length}
            defaultPageSize={recordsPerPage}
            defaultPageIndex={pageNo}
            onPageSizeChange={onPageSizeChange}
          />
        </>
      )}
      {share.data && (
        <ModalNew
          toggleModal={share.data.length > 0}
          setToggleModal={() =>
            setShare({
              data: [],
              isLoading: false,
              isSuccess: false,
              isError: false,
              message: ''
            })
          }
        >
          <Card header="Share Hub Link">
            <Span style={{ fontSize: '14px', fontWeight: 600 }}>Arrival:</Span>
            <CopyText
              dataTestid="share-link1"
              link={share.data[0]}
              view="Arrival"
            />
            <Span style={{ fontSize: '14px', fontWeight: 600 }}>
              Departure:
            </Span>
            <CopyText
              dataTestid="share-link2"
              link={share.data[1]}
              view="Departure"
            />
            <Span style={{ fontSize: '14px', fontWeight: 600 }}>
              Arrival And Departure:
            </Span>
            <CopyText
              dataTestid="share-link3"
              link={share.data[2]}
              view="Arrival And Departure"
            />
          </Card>
        </ModalNew>
      )}
    </RenderControl>
  )
}
